export const joinParts = (...parts: (string | null | undefined)[]) =>
    parts
        .map((p) => (typeof p === 'string' ? p.trim() : p))
        .filter((p): p is string => !!p && p.length > 0)
        .join(' - ') || undefined
